import {useMemo} from 'react'
import {Lang} from 'yougile-lang'
import {ChatMessage, DataObjectId, Hub} from 'yougile-model'
import {Accounts} from '@client/accounts'
import {Sync} from '@client/sync'
import {ChatMessageUtils} from '@extensions/chat-message-utils'
import {ChatSubscribers} from '@extensions/chat-subscribers'
import {Feedback} from '@extensions/feedback'
import {globals} from '@extensions/globals-base'

export const useSeenBy = (
  msg: ChatMessage,
  hub?: Hub,
  isComments?: boolean
) => {
  const isFeedbackTicket =
    !!Feedback.column && hub?.location === Feedback.column.id

  const seenBy = useMemo(
    () =>
      !isFeedbackTicket && hub ? ChatMessageUtils.seenBy(msg, hub) : undefined,
    [isFeedbackTicket, hub, msg]
  )

  const seenByTitle = useMemo(() => {
    if (isComments || !hub) {
      return ''
    }
    const box = Sync.getOrCurrent(hub)
    const userIds = ChatSubscribers.getSubscribedUserIds(hub).filter(
      (uid: DataObjectId) =>
        uid !== globals.currentUserId &&
        (hub.companyId === Sync.profileId || box.isUserInCompany(uid))
    )
    if (userIds.length === 0) {
      return ''
    }
    const seenBy = userIds.filter(
      (uid: DataObjectId) => hub.chat.getLastSeenMessage(uid) >= msg.timestamp
    )

    if (seenBy.length === userIds.length) {
      return Lang.msg.msgSeenEverybody
    } else if (seenBy.length === 0) {
      return Lang.msg.msgSeenNobody
    } else {
      return (
        Lang.msg.msgSeenSomebody +
        ': ' +
        seenBy.map((uid: DataObjectId) => Accounts.getName(uid)).join(', ')
      )
    }
  }, [msg, hub])

  return {seenBy, seenByTitle}
}
